<template>
  <kst-section :title="Info.Section.LowStockReminder.Title">
    <List
      :userLowStockEmailList="userLowStockEmailList"
    />

    <template #bottom>
      <kst-button action-mode
        class="is-primary"
        :label="Model.Email.ModuleType.New.Name"
        :moduleType="Model.Email.ModuleType.New"
        @click="handleNew"
      />
    </template>
  </kst-section>
</template>

<script>
import Catalog from "../CpCatalog.js";
import Info from "../CpInfo.js";
import Model from "../CpModel.js";

import List from "./CpE_LowStockReminder_List.vue";

export default {
  components: {
    List
  },
  props: {
    userData: Object,
    userLowStockEmailList: Array
  },
  data: () => ({
    Catalog: Catalog,
    Info: Info,
    Model: Model
  }),
  methods: {
    handleNew() {
      this.userLowStockEmailList.push(
        Model.createEmailDetails()
      );
    }
  }
}
</script>